// Import model
import { CatalogItemCondition } from '../models/CatalogItemCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { CatalogItemIndexedFields } from '../models/CatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { CatalogItemIndexedFieldsSerializer } from './CatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CatalogItemCondition - handles JSON serialization and deserialization with type validation
 */
export class CatalogItemConditionSerializer {
  /**
   * Deserializes a JSON string into a CatalogItemCondition instance
   */
  static deserialize(json: string): CatalogItemCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CatalogItemCondition instance
   */
  static fromObject(obj: any): CatalogItemCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CatalogItemCondition');
    }


    const instance: CatalogItemCondition = {
      fieldName: obj['fieldName'] as CatalogItemIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CatalogItemCondition instances
   */
  static deserializeArray(json: string): CatalogItemCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CatalogItemCondition instance to a JSON string
   */
  static serialize(instance: CatalogItemCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CatalogItemCondition instance to a plain object
   */
  static toObject(instance: CatalogItemCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of CatalogItemCondition instances to a JSON string
   */
  static serializeArray(instances: CatalogItemCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
